import { Injectable } from "@angular/core";
import { Firestore } from '@angular/fire/firestore';
import { Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { doc } from "firebase/firestore";
import { docData } from "rxfire/firestore";
import { catchError, map, of, take } from "rxjs";
import { CommonService } from "./common/common.service";

@Injectable({
  providedIn: "root",
})
export class AnimationService {
  constructor(
    private firestore: Firestore,
    private router: Router,
    private authService: AuthService,
    private commonService: CommonService
  ) {

    this.router.events.pipe(take(1)).subscribe((event: any) => {
      if (event?.url) {
        const urlParams = new URLSearchParams(event.url.split('?')[1]);
        const location_id = urlParams.get('animation');

        if (location_id) {
          this.commonService.getUid("").pipe(take(1)).subscribe(uid => {
            if (!uid) return;

            this.authService.getV2CloudFunction("updatemicroanimationv2", {
              userId: uid,
              locationIds: location_id,
              status: true
            }).subscribe();
          });
        }
      }
    });

  }

  getAnimationFB(userId: string) {
    if (!userId) return of({ general: [], menu: [] });

    // Live listener so Console status flips appear without a full remount
    const docRef = doc(this.firestore, `users/${userId}/micro_animations/list`);
    return docData(docRef).pipe(
      map((data) => data || { general: [], menu: [] }),
      catchError(() => of({ general: [], menu: [] }))
    );
  }


  getAnimationBasedOnCategory(userId: string, category: string) {
    return this.getAnimationFB(userId).pipe(
      map((response: Data | undefined) => {
        if (!response || !category) return [];
        return Array.isArray(response?.[category])
          ? response?.[category]
          : response?.[category]
            ? [response?.[category]]
            : [];
      }),
      catchError(() => {
        return of([]); // Return empty array as fallback
      })
    );
  }
  listenToInboxStatus(userId: string) {
    // Reference to the document
    const docRef = doc(this.firestore, `users/${userId}/in_app_notification/status`);

    // Get document data as an observable
    return docData(docRef);
  }

}
